import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {SQFT_AR3D_POPUP_CONTENT_TYPE} from "../../constants";
import ThreeDContent from "./ar3d/ThreeDContent";
import ArContent from "./ar3d/ArContent";

const AR3DPopup = (props) => {
  const {ar3dPopup} = props;
  const [popupContent, setPopupContent] = useState(null)

  useEffect(() => {
    switch (ar3dPopup.contentType) {
      case SQFT_AR3D_POPUP_CONTENT_TYPE.threeD : {
        setPopupContent(<ThreeDContent/>);
        break;
      }
      case SQFT_AR3D_POPUP_CONTENT_TYPE.ar : {
        setPopupContent(<ArContent/>);
        break;
      }
      default : {
        setPopupContent("");
      }
    }
  }, [ar3dPopup])

  return (
    <div className={"full-screen-wrapper " + (ar3dPopup.isOpened ? "" : "hidden")}>
      {
        popupContent
      }
    </div>
  )
};

const mapStateToProps = (store) => ({
  ar3dPopup: store.sqftMenuState.ar3dPopup
});

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(AR3DPopup);
